type FanIconProps = {
  color?: string;
  size?: string;
}

export const FanRCIcon = ({
  color = '#9C9C9C',
  size,
}: FanIconProps): JSX.Element => (
  <svg width={size ?? 24} height={size ?? 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.83 10.772C14.4396 9.38325 14.8061 8.02435 14.9302 6.69614C15.116 5.22437 14.2868 4 12.0002 4C9.71355 4 8.88435 5.22527 9.07012 6.69614C9.19424 8.02435 9.56071 9.38325 10.1704 10.772M12.9874 16.4171C13.8065 17.6766 14.7243 18.6951 15.7376 19.4744C16.8353 20.3827 18.2429 20.2265 19.3862 18.1091C20.5295 15.9918 19.952 14.6112 18.6685 14.0478C17.5302 13.4988 16.2468 13.1584 14.8164 13.0293M9.18356 13.0293C7.75399 13.1584 6.47051 13.4988 5.33311 14.0478C4.04793 14.6103 3.47036 15.9918 4.61368 18.1091C5.75699 20.2265 7.16376 20.3818 8.26232 19.4744C9.2756 18.6951 10.1935 17.6766 11.0134 16.4171M14.5335 13.0293C14.5335 14.5253 13.3994 15.7381 12.0003 15.7381C10.6013 15.7381 9.46714 14.5253 9.46714 13.0293C9.46714 11.5333 10.6013 10.3205 12.0003 10.3205C13.3994 10.3205 14.5335 11.5333 14.5335 13.0293Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
